import { Tabs } from "antd";
import React from "react";
import CashBookingSteps from "../BookingSteps";

const CashBookingTabs = () => (
  <Tabs
    defaultActiveKey="1"
    items={[
      {
        label: "Cash Booking",
        key: "1",
        children: <CashBookingSteps />,
      },
    ]}
  />
);

export default CashBookingTabs;
